<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle :title="$route.meta.title"></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="12" hidden>
              <b-form-group>
                <label>Image base url</label>
                <b-form-input type="text" id="uri" v-model="uri" disabled
                              :value="uri"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Nome del file <required-field /></label>
                <b-input-group :append="fileExtension ? fileExtension : ''" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input type="text" id="filename" v-model="filename"
                                :value="filename" :state="Boolean(filename)" aria-required="true" :required=true></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="8">
              <b-form-group>
                <label>Path addizionale</label>
                <b-input-group prepend="medmaker2:/images/" class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-input type="text" id="path" v-model="path"
                                :value="path" :state="errors.some((e) => e.field === 'path')?false:null" aria-required="true" :required=true></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <!-- Styled -->
              <b-form-group :description="'Dimensione massima dei file: ' + imageSizeHumanReadable">
                <label>Immagine <required-field /></label>
                <b-form-file
                  v-model="file"
                  :state="Boolean(file) && fileMeetsRequireFileMaxSize"
                  :placeholder="file ? file.name : 'Seleziona il file o trascinalo qui...'"
                  @change="onFileChanged"
                  accept="image/jpeg, image/png"
                  drop-placeholder="Trascinalo qui..."
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-container fluid class="p-4" v-if="url">
            <b-row>
              <b-col offset-md="4" md="4" align-self="center">
                <b-img thumbnail fluid :src="url" alt="Image Preview"></b-img>
              </b-col>
            </b-row>
          </b-container>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <button class="btn btn-success float-right mr-3 padder"
                        :disabled="!saveButtonIsActive"
                        type="button" @click="onUpload"
                >{{ $t('actions.save') }}
                </button>
                <router-link class="btn btn-primary float-right" role="button" :to="{name: 'uploadImageListRoute'}">
                  {{$t('actions.abort')}}
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle'
  // require styles
  import miniToastr from 'mini-toastr' //ES6
  import UploadImageService from "@/services/UploadImageService"
  import RequiredField from "../../components/RequiredField";

  const uploadImageService = UploadImageService.build();
  const DEFAULT_IMAGE_MAX_SIZE = (1 * 1024 * 1024);
  export default {
    name: 'ImageUploadNew',
    components: {
      RequiredField,
      PageTitle
    },
    computed: {
      uri: function () {
        let additionalPath = this.path ? "/" + this.path : "";
        return `medmaker2:${additionalPath}/${this.filename}${this.fileExtension}`
      },
      saveButtonIsActive: function () {
        return !!(this.filename && this.file && this.fileMeetsRequireFileMaxSize);
      },
      imageSizeHumanReadable : function () {
        const bytes = this.imageMaxSize;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      },
      fileMeetsRequireFileMaxSize: function () {
        return this.selectedFile.size < this.imageMaxSize
      }
    },
    data() {
      return {
        file: undefined,
        filename: '',
        path:'',
        errors: [],
        selectedFile: null,
        imageMaxSize: DEFAULT_IMAGE_MAX_SIZE,
        url: null,
        fileExtension: null
      }
    },
    created() {
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.maxImageSize()
    },
    methods: {
      async maxImageSize(){
        try{
          const size = await uploadImageService.maxsize();
          this.imageMaxSize = size.maxSize;
        } catch (e) {
          this.imageMaxSize = DEFAULT_IMAGE_MAX_SIZE;
          console.error(e.message)
        }
      },
      onFileChanged (event) {
        this.selectedFile = event.target.files[0];

        if (!this.fileMeetsRequireFileMaxSize) {
          miniToastr.error('Il file supera la dimensione massima consentita');
        }

        const fileregex = new RegExp(/\.[a-z]+$/, 'i');
        this.fileExtension = fileregex.exec(this.selectedFile.name)[0];
        this.url = URL.createObjectURL(this.selectedFile);
      },
      async onUpload() {

        const formData = new FormData();
        formData.append('uploadedImage', this.selectedFile, this.selectedFile.name);
        formData.append('uri', this.uri);
        try{
          await uploadImageService.upload(formData);

          this.$router.push({name: 'uploadImageListRoute'});
          miniToastr.success("Immagine caricata con successo");
        } catch (e) {
          miniToastr.error(e.message);
        }
      }
    }
  }
</script>
